<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Tendering Proces - Step 2 of 4 (Supplier/vendor selection & send RFQ)
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="backStep()">
            <i class="fa fa-backward"></i> Prev.Step
          </button>
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <!-- <button class="btn btn-primary mr-1" @click="printRfq()">
            <i class="fa fa-print"></i> RFQ
          </button> -->
          <button class="btn btn-primary mr-1" @click="nextStep()">
            <i class="fa fa-forward"></i> Next Step
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tendering Number</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.nomor" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tendering Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tanggal" type="date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Note/Description</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.uraian" placeholder="Note/Description" disabled></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <h4 class="mt-2">Item Requested</h4>
      <div class="tbl-wrap" style="min-height: 200px !important;">
        <b-table
          class="mb-0"
          ref="tblRequestItem"
          outlined striped hover small
          style="font-size:smaller;"
          :items="requestItem.items"
          :fields="requestItem.fields"
          @row-clicked="rowClicked"
        >
          <template v-slot:cell(index)="data">{{data.index + 1}}</template>
          <template v-slot:cell(itemname)="data">
              {{data.item.partnumber}} 
              | {{data.item.itemname}}
          </template>
          <template v-slot:cell(jasa)="data">
            <span v-if="(data.item.jasa==1)">Service</span>
            <span v-else>Material</span>
          </template>

          <template v-slot:cell(QtyRequest)="data">
              {{data.item.QtyRequest}} {{data.item.invunitom}}
          </template>
          <template v-slot:cell(qtyPurchase)="data">
                <b-input-group>
                    <b-form-input v-model="data.item.qtyPurchase" size="sm"></b-form-input>
                    <b-form-input v-model="data.item.PackUnit" class="ml-1" size="sm"></b-form-input>
                </b-input-group>              
          </template>
          <template v-slot:cell(HEAD_selected)="data">
            <b-form-checkbox @click.native.stop v-model="selectAllItem" style="width:20px;">select</b-form-checkbox>
          </template>
        </b-table>
        <!-- <b-form-row class="ml-1 mr-1">
          <b-col md="6">
            Showing
            {{(requestItem.page - 1) * requestItem.limit + 1}}
            to
            {{requestItem.page * requestItem.limit}}
            of
            {{requestItem.total}}
            entries
          </b-col>
          <b-col md="6">
            <b-pagination
              align="right"
              :total-rows="requestItem.total"
              :per-page="requestItem.limit"
              v-model="requestItem.page"
            ></b-pagination>
          </b-col>
        </b-form-row> -->
      </div>
        <b-form-row class="mt-3">
          <b-col md="8">
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:160px !important;">
                  <strong>Add Supplier/Vendor</strong>
                </label>
              </b-input-group-prepend>
              <b-form-input readonly v-model="model.vendorinfo"></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuVendorShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-form-row>
        <div class="tbl-wrap">
          <b-table
            class="mb-0"
            ref="tblvendors"
            outlined
            striped
            hover
            small
            style="font-size:smaller;"
            :items="vendors.items"
            :fields="vendors.fields"
          >
            <template v-slot:cell(index)="data">{{data.index + 1}}</template>
            <template v-slot:cell(vendor_phone)="data">
              <span v-if="(data.item.vendor_phone)">P.{{data.item.vendor_phone}}</span>&nbsp;
              <span v-if="(data.item.vendor_fax)">F.{{data.item.vendor_fax}}</span>
            </template>
            <template v-slot:cell(selected)="data">
              <b-form-checkbox @click.stop v-model="data.item.selected" style="width:20px;"></b-form-checkbox>
            </template>
          </b-table>
        </div>
      <b-row class="justify-content-center mb-2">
        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="saveAndNext()">
          <i class="fa fa-save"></i> Save & Next
        </button>
        <button class="btn btn-danger mr-1" @click="close()">
          <i class="fa fa-close"></i> Close
        </button>
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuVendorShow"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
    >
      <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="showForm" header-bg-variant="primary"  title="Edit Specification Item" size="lg" :centered="true" @ok="handleOk" ok-title="Save">
              <b-form @submit.stop.prevent="save">
                    <b-row>
                        <b-col lg="5" >
                        <b-input-group>
                            <b-input-group-prepend><label>Request Item</label></b-input-group-prepend>
                            <b-form-input v-model="frmdata.partnumber" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="7">                            
                            <b-form-input v-model="frmdata.itemname" readonly></b-form-input>                                        
                        </b-col>
                    </b-row >    
                  <b-form-row>
                    <b-col lg="6">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Qty. Inventory Requested</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.QtyRequest" readonly></b-form-input>
                          <b-form-input class="ml-1" readonly v-model="frmdata.invunitom" ></b-form-input>
                      </b-input-group>
                    </b-col>
                    <b-col lg="6">                            
                      <b-input-group>
                          <b-input-group-prepend><label>Quantity Purchase Unit</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.qtyPurchase" type="number" :state="!$v.frmdata.qtyPurchase.$error" :min="1"></b-form-input>
                          <b-form-input class="ml-1" v-model="frmdata.PackUnit" :state="!$v.frmdata.PackUnit.$error"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-form-row >     
                  <b-input-group>
                      <b-input-group-prepend><label>Specification</label></b-input-group-prepend>
                      <b-form-textarea :rows="6" :max-rows="18" v-model="frmdata.spekdetail" :state="!$v.frmdata.spekdetail.$error"></b-form-textarea>
                  </b-input-group>
              </b-form>
        </b-modal>    
  </div>
</template>
<style lang="scss">
.tbl-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  min-height: 100px;
  border: 1px solid silver;
}
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from "moment";
import lkuVendor from "../lookup/lkuVendor";
import proctender from "../../apis/proctender";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  requiredUnless,
  minValue,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading,lkuVendor },
  mixins: [validationMixin],
  validations: {
    model: {
      nomor: { required },
      tanggal: { required },
      uraian: { required }
    },
    frmdata: {
      qtyPurchase: { required , minValue:minValue(0.01) },
      PackUnit: { required },
      spekdetail: { required }
    }
  },
  data() {
    return {
      saveEnabled: true,
      selectAllItem: false,
      horizontal: true,
      lkuVendorShow: false,
      isLoading:false,
      showReport:false,
      showForm:false,
      frmdata:{qtyPurchase:'',PackUnit:'',spekdetail: ''},
      reportUrl: null,        
      uanguser: this.$store.state.user.matauang,
      model: { 
        nomor: "", 
        tanggal: "", 
        uraian: "", 
        requisition: "" 
      },
      selectedItem:{},
      requestItem: {
        items: [
        ],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "itemname",
            label: "Master Item",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "jasa",
            label: "_",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "spekdetail",
            label: "Specification/Description",
          },
          {
            key: "QtyRequest",
            label: "Qty.Inventory Requested",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "qtyPurchase",
            label: "Qty. Purchase",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center"
          }
        ],
        total: 0
      },
      vendors: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "vendor_code",
            label: "Vendor Code",
            thStyle: "width:100px"
          },
          {
            key: "vendor_code",
            label: "Vendor Name",
            thStyle: "width:240px"
          },
          {
            key: "vendor_phone",
            label: "Phone/Fax",
            thStyle: "width:150px"
          },
          {
            key: "vendor_address",
            label: "Address"
          },
          {
            key: "selected",
            label: "select",
            thStyle: "width:20px",
            sortable: true
          }
        ],
        page: 1,
        limit: 5,
        total: 0
      }
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch: {
    selectAllItem: function(newval) {
      for (let index = 0; index < this.requestItem.items.length; index++) {
        this.requestItem.items[index].selected = newval;
      }
      // this.$forceUpdate();
    }
  },
  created: async function() {
    //   this.currency = await proctender.currency();
      // console.log("Created event, please wait",this.$route.params);

    if (this.$route.params.idTender) {
      try {
            this.isLoading=true;
        const data = await proctender.detailStep2(this.$route.params);
            this.isLoading=false;
        const row = data[0][0];
        this.saveEnabled;
        // =(row.send2wf === 0);
        row.tanggal = row.tanggal
          ? moment(row.tanggal).format("YYYY-MM-DD")
          : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.requestItem.items = data[1];
        this.vendors.items = data[2];
        this.vendors_item = data[3];
        this.vendors.items.forEach((item, idx) => {
          this.vendors.items[idx].selected=true;
        });
        this.vendors_item.forEach((vnd, idx) => {
          const ada = this.vendors.items.find( v=>v.idVendor==vnd.idvendor);
          if (!(ada)){
            vnd.idVendor==vnd.idvendor;
            this.vendors.items.push(vnd);
          }
        });
        this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
        router.push({name : "procurement.tendering"});
    } 
  },
  methods: {
    rowClicked(record, index) {
      if (this.selectedItem.idTenderItem == record.idTenderItem) {
          this.editSpekItem();
      } else {
        if ((this.selectedItem) && (this.selectedItem._rowVariant)) {
            delete this.selectedItem._rowVariant;
        }
        this.selectedItem = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },
    editSpekItem: function(){
        if (this.selectedItem.idTenderItem) {
            for (var key in this.selectedItem) {
                this.frmdata[key] = this.selectedItem[key];
            }
          this.showForm=true;
          this.$forceUpdate();
        } 
    },
    handleOk: function(evt) {
        evt.preventDefault()
        if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            //this.save()
            this.selectedItem.qtyPurchase=this.frmdata.qtyPurchase;
            this.selectedItem.PackUnit=this.frmdata.PackUnit;
            this.selectedItem.spekdetail=this.frmdata.spekdetail;
            this.showForm=false;
        }
    },    
    backStep() {
      // update status=1 to PREVIOUS STEPS
      // hapus semua vendor/supplier yang pernah dipilih
      // router.push({name :`procurement.tenderingfrm${this.mode.idstatus}`, params: { idTender: this.model.idTender}});
      router.push({
        name: `procurement.tenderingfrm1`,
        params: { idTender: this.model.idTender }
      });
    },
    nextStep: async function() {
      // const data = await proctender.detail(this.model);
      // if (data[2].length>0) {
      // update field status=3 to NEXT STEPS
      // router.push({name :`procurement.tenderingfrm${this.mode.idstatus}`, params: { idTender: this.model.idTender}});
      router.push({
        name: `procurement.tenderingfrm3`,
        params: { idTender: this.model.idTender }
      });
      // } else {
      //     toastr.error('Please fill at least 1(one) Vendor/Supplier selected, then click Save', 'ERROR MESSAGE');
      // }
    },
    save: async function() {
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.model.idTender = this.model.idTender || "";
          this.model.nomor = this.model.nomor || "";
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.terms = this.model.terms;
          row.tanggal = moment(row.tanggal).format("YYYY-MM-DD");
          //prItemSummary
          row.itemSmry = this.requestItem.items;
          //vendor line
          row.lines = this.vendors.items.reduce((newArr, item) => {
            if (item.selected) {
              newArr.push(item);
            }
            return newArr;
          }, []);
        console.log('tender vendor : ', row.lines);

          if (row.lines.length > 0) {
            console.log('row saveStep2of4',row)
            console.log('=================')
            await proctender.saveStep2of4(row);
            toastr.success("Saved successfully", "Selected Vendor/supplier");
          } else {
            toastr.error(
              "Please fill at least 1(one) Supplier/vendor",
              "ERROR MESSAGE"
            );
          }
        } catch (error) {
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "Save Order Error");
        }
      }
    },
    saveAndNext:async function(){
        this.save()
        setTimeout(() => {
          this.nextStep();          
        }, 1000);
    },
    onSelectLkuVendor: async function(_selected) {
      const findVendor = this.vendors.items.find(x=>x.vendor_code === _selected.vendor_code )
      if(findVendor){
        toastr.error("Vendor already exist in Supplier/Vendor list.", "Add Vendor Error");
      }else{
        _selected.vendorinfo =_selected.vendor_code.trim() + " | " + _selected.vendor_code.trim();
        _selected.vendor_address = `${_selected.vendor_address1} ${_selected.vendor_address2} ${_selected.vendor_city}`;

        _selected.selected = true;
        this.vendors.items.push(_selected);
        this.lkuVendorShow = false;
      }


    },
    close() {
      router.push({name : "procurement.tendering"});
    },

  }
};
</script>
